import React from "react";
import { faWalking } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@/components/button";

export default function TimePickerPreview(props) {
  return (
    <li className="overflow-hidden inline-block">
      <Button
        type={
          parseInt(props.currentValue) === props.delay ? "positive" : "neutral"
        }
        onClick={props.onClick}
        data-delay={props.delay}
      >
        <div>{props.delay} ms</div>
        <div
          className="timepicker-preview-animate"
          style={{
            animationName: "timepicker-preview-walk",
            animationDuration: `${props.delay * 20}ms`,
            animationIterationCount: "infinite",
          }}
        >
          <FontAwesomeIcon icon={faWalking} />
        </div>
      </Button>
    </li>
  );
}
